import React, { useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import bcryptjs from 'bcryptjs';

const Login = ({ onLoginSuccess, setShowLoginModal }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const usersRef = collection(db, 'users');
      const q = query(usersRef, where('username', '==', username));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        const userDoc = querySnapshot.docs[0];
        const userData = userDoc.data();

        // 🔹 Compare hashed password using bcrypt
        const passwordMatch = await bcryptjs.compare(password, userData.password);

        if (passwordMatch) {
          console.log('✅ Password matches! Logging in...');
          onLoginSuccess(userData);
          setShowLoginModal(false);
        } else {
          console.log('❌ Invalid password.');
          setError('Invalid password. Please try again.');
        }
      } else {
        console.log('❌ No user found');
        setError('No user found with that username.');
      }
    } catch (err) {
      console.error('🚨 Error during login:', err);
      setError('An error occurred. Please try again.');
    }
  };

  return (
    <form onSubmit={handleLogin}>
      <input 
        type="text" 
        placeholder="Username"
        value={username} 
        onChange={(e) => setUsername(e.target.value)} 
        required 
      />

      <input 
        type="password" 
        value={password} 
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)} 
        required 
      />

      <button type="submit">Login</button>
      {error && <p>{error}</p>}
    </form>
  );
};

export default Login;
